module.exports = __webpack_public_path__ + "img/answers_card_error.b994c359.svg";